export default __webpack_public_path__ + "static/media/20210830154122.1c70796c.png";